export type Lang = 'zh' | 'en';

/**
 * UI strings are app-owned; station and line names come from the graph, which
 * carries both languages from TDX.
 */
export const STRINGS = {
  zh: {
    title: '捷運即時',
    live: '即時',
    connecting: '連線中',
    stale: '資料延遲',
    /** Short form for the header pill; the banner carries the full sentence. */
    downShort: '無法取得',
    down: '即時資料無法取得',
    downHint: '顯示的是最後一次成功更新的畫面',
    allLines: '全線',
    trains: '列車',
    noService: '目前沒有行駛中的列車',
    noServiceHint: '末班車已收班，服務時間外',
    updated: '更新於',
    secondsAgo: (s: number) => `${s} 秒前`,
    minutesAgo: (m: number) => `${m} 分前`,
    langToggle: 'EN',
    offline: '連線中斷',
  },
  en: {
    title: 'Taipei Metro Live',
    live: 'Live',
    connecting: 'Connecting',
    stale: 'Delayed',
    /** Short form for the header pill; the banner carries the full sentence. */
    downShort: 'Unavailable',
    down: 'Live data unavailable',
    downHint: 'Showing the last successful update',
    allLines: 'All lines',
    trains: 'trains',
    noService: 'No trains running',
    noServiceHint: 'The last train has run — outside service hours',
    updated: 'Updated',
    secondsAgo: (s: number) => `${s}s ago`,
    minutesAgo: (m: number) => `${m}m ago`,
    langToggle: '中',
    offline: 'Connection lost',
  },
} as const;

export const t = (lang: Lang) => STRINGS[lang];

const STORAGE_KEY = 'mrt.lang';

export function loadLang(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'zh' || saved === 'en') return saved;
  } catch {
    // Private mode or a Capacitor container without storage — fall through.
  }
  return navigator.language?.startsWith('zh') ? 'zh' : 'en';
}

export function saveLang(lang: Lang): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // Persisting the choice is a convenience, never a requirement.
  }
}
